import { render, staticRenderFns } from "./PublishToTheSource.vue?vue&type=template&id=4925e3ca&scoped=true&"
import script from "./PublishToTheSource.vue?vue&type=script&lang=js&"
export * from "./PublishToTheSource.vue?vue&type=script&lang=js&"
import style0 from "./PublishToTheSource.vue?vue&type=style&index=0&id=4925e3ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4925e3ca",
  null
  
)

export default component.exports